/**
 * useFormEmail
 *
 * Owns the "send via email" action for the active form: gates on required
 * fields, then mounts `FormEmailModal` for the current form. Composed by
 * `FormWorkflowActionProvider` so the menus and the command palette share one
 * gate and one mounted modal. Returns the email handler and the modal element
 * the provider renders.
 */

import { useCallback, useState } from 'react';
import FormEmailModal from '@/components/modals/FormEmailModal';
import { checkRequiredFields } from './checkRequiredFields';

type UseFormEmailParams = {
  formId: string;
  formNumber?: string;
};

export const useFormEmail = ({ formId, formNumber }: UseFormEmailParams) => {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  const handleEmailClick = useCallback(() => {
    if (!checkRequiredFields()) return;
    setIsEmailModalOpen(true);
  }, []);

  const closeEmailModal = useCallback(() => setIsEmailModalOpen(false), []);

  const emailModal = isEmailModalOpen ? (
    <FormEmailModal onCancel={closeEmailModal} formId={formId} formNumber={formNumber} />
  ) : null;

  return { handleEmailClick, emailModal };
};
